import { Award, CheckSquare, ClipboardCheck, FileText } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "audits",
  slug: "auditorias",
  icon: ClipboardCheck,
  useCases: [
    { key: "digital", icon: ClipboardCheck },
    { key: "actionPlans", icon: FileText },
    { key: "certifications", icon: Award },
    { key: "compliance", icon: CheckSquare },
  ],
  benefits: ["speed", "compliance", "nonConformities", "paperless"],
  formApplication: "Auditorias e Certificações",
};

const Auditorias = () => <ApplicationPage config={config} />;

export default Auditorias;
